module.exports = __webpack_public_path__ + "img/cabbage-posterized-large-alpha.837279d5.png";